import { InternationalMarket, SiteId } from '@chewy/market-handler';

import { getMarket } from './marketHandler';

interface MarketConfig {
  gtmId: string;
  siteId: SiteId;
  cancellationKey: string;
  paymentMethodKey: string;
  preferredPaymentKey: string;
  loyaltyBasePath: string;
  walletPath: string;
}

//gtm ids
const CANADA_GTM_CONTAINER_ID = 'GTM-T5F7G48';
const GTM_CONTAINER_ID = 'GTM-5X325N';

const CA_PREFIX = '/ca/api/loyalty-orchestrator';

// cancellation endpoint
const CANCELLATION_RESPONSE_KEY = '/loyalty-orchestrator/v1/customers/cancellation';

//payment
export const US_PAYMENT_METHOD_QUERY_KEY = '/api/payments/v1/wallets/primary/payment-methods';
export const CA_PAYMENT_METHOD_QUERY_KEY = '/ca/v1/wallets/primary/payment-methods';

//preferred payment
export const PREFERRED_PAYMENT_QUERY_KEY = '/loyalty-orchestrator/v1/customers/preferred-payment';

//loyalty
export const LOYALTY_BASE_ENDPOINT = '/loyalty-orchestrator/v1/memberships';

export const marketConfig: { [key: string]: MarketConfig } = {
  [InternationalMarket.enCA]: {
    gtmId: CANADA_GTM_CONTAINER_ID,
    siteId: SiteId.enCA,
    cancellationKey: `${CA_PREFIX}${CANCELLATION_RESPONSE_KEY}`,
    paymentMethodKey: CA_PAYMENT_METHOD_QUERY_KEY,
    preferredPaymentKey: `${CA_PREFIX}${PREFERRED_PAYMENT_QUERY_KEY}`,
    loyaltyBasePath: `${CA_PREFIX}${LOYALTY_BASE_ENDPOINT}`,
    walletPath: '/ca',
  },
  [InternationalMarket.enUS]: {
    gtmId: GTM_CONTAINER_ID,
    siteId: SiteId.enUS,
    cancellationKey: CANCELLATION_RESPONSE_KEY,
    paymentMethodKey: US_PAYMENT_METHOD_QUERY_KEY,
    preferredPaymentKey: PREFERRED_PAYMENT_QUERY_KEY,
    loyaltyBasePath: LOYALTY_BASE_ENDPOINT,
    walletPath: '/api/payments',
  },
  // Add more markets as needed
};

export const getMarketConfig = (marketCode: string): MarketConfig => {
  return marketConfig[marketCode];
};

export const getCurrentMarketConfig = (): MarketConfig => {
  const marketCode = getMarket();
  return getMarketConfig(marketCode ?? InternationalMarket.enUS);
};
